import MainLayouts from "layouts/MainLayouts";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStatusDomain, backorderStatus } from "features/domain/domainsSlice";
import Spinner from "react-bootstrap/Spinner";
import { addDomainToCart } from "features/common/layouts/cartSlice";
// import custom from "../../../assets/scss/Domain.module.scss"; // File sudah dihapus
import { useQuery } from "helpers/utils";
import {
  notifyWarning,
  notifyError,
  notifySuccess,
} from "components/ToastMessage";

const DomainBackorder = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const result = useSelector((state) => state.domain);
  const backorder = useSelector((state) => state.cart.productsList);
  const [domain, setDomain] = useState("");

  const handlerSendToCart = (e) => {
    if (domain) {
      const splitDomain = domain.split(".");
      if (!domain || splitDomain[0] === undefined || splitDomain[0] === "") {
        notifyWarning("Domain Backorder Anda Kosong!");
        return;
      }

      if (
        !splitDomain[1] ||
        splitDomain[1] === undefined ||
        splitDomain[1] === ""
      ) {
        notifyWarning("Ekstensi Domain Backorder Anda Kosong!");
        return;
      }

      e.preventDefault();
      dispatch(getStatusDomain(domain));
    }
  };

  useEffect(() => {
    if (query.domainbackorder) {
      const splitDomain = query.domainbackorder.split(".");
      if (
        !query.domainbackorder ||
        splitDomain[0] === undefined ||
        splitDomain[0] === ""
      ) {
        notifyWarning("Domain Backorder Anda Kosong!");
        return;
      }

      if (
        !splitDomain[1] ||
        splitDomain[1] === undefined ||
        splitDomain[1] === ""
      ) {
        notifyWarning("Ekstensi Domain Backorder Anda Kosong!");
        return;
      }
      dispatch(getStatusDomain(query.domainbackorder));
    }
  }, [query.domainbackorder, dispatch]);

  useEffect(() => {
    if (result) {
      if (result.backorder_status === false) {
        notifyError(
          "Domain tersebut belum terdaftar sebagai domain backorder!"
        );
      } else if (result.backorder_status === true) {
        const { domain, status, duration, priceRenew } = result.domain_register;
        dispatch(
          addDomainToCart({
            name: domain,
            price: "150000",
            type: "backorder",
            domain: "backorder",
            pid: 382,
            customfields: [{ id: 1215, value: domain }],
          })
        );
        dispatch(
          addDomainToCart({
            name: domain,
            price: priceRenew,
            status,
            domain,
            duration,
            priceRenew,
            type: "backorder-register",
          })
        );
        const domainBackorder = backorder.filter(
          (domain) => domain.type === "backorder-register"
        );
        dispatch(backorderStatus("idle"));
        if (domainBackorder.length > 0) {
          notifyError("Tidak dapat memesan 2 atau lebih domain backorder");
        } else {
          notifySuccess("Domain anda telah ditambahkan ke keranjang");
        }
      }
    }
  }, [dispatch, result, backorder]);

  return (
    <MainLayouts summary={false}>
      <div className="card mb-3 shadow-sm" style={{ minHeight: "100px", borderRadius: "16px", borderColor: "transparent" }}>
        <div className="card-body">
          <div className="form-check py-1 px-4">
            <input
              type="radio"
              className="form-check-input"
              name="domainBackorder"
              id="domainBackorder"
              value="domainBackorder"
              defaultChecked={true}
            />
            <label
              htmlFor="domainBackorder"
              className="form-check-label fw-bold"
              style={{ fontSize: "18px", marginLeft: "20px" }}
            >
              Domain Backorder
            </label>
            <p className="mb-0 mt-2" style={{ marginLeft: "21px" }}>
              Peroleh domain terbaik yang ingin Anda miliki saat domain tersebut tersedia untuk pendaftaran
            </p>
          </div>

          <div className="px-3 px-md-4 mt-3">
            <div className="mb-3">
              <label htmlFor="domainBackorderInput" className="form-label fw-bold">
                Nama Domain Backorder
              </label>
              <input
                type="text"
                className="form-control"
                id="domainBackorderInput"
                placeholder="Contoh: namadomainanda.com"
                onChange={(e) => setDomain(e.target.value)}
                value={domain}
              />
            </div>

            {result.backorder_status === false && domain && (
              <div className="alert alert-danger d-flex align-items-center mb-3" role="alert">
                <svg className="flex-shrink-0 me-2" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                </svg>
                <div>
                  <strong>{domain}</strong> tidak tersedia untuk backorder
                </div>
              </div>
            )}

            <div className="text-center mt-4">
              {result.status === "loading" ? (
                <button
                  className="btn btn-cta fw-bold py-2 px-5 rounded-5"
                  disabled={true}
                >
                  <Spinner
                    animation="border"
                    className="me-2"
                    size="sm"
                  />
                  Memproses...
                </button>
              ) : (
                <button
                  className="btn btn-cta fw-bold py-2 px-5 rounded-5"
                  onClick={handlerSendToCart}
                  disabled={!domain}
                >
                  Tambahkan ke Keranjang
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </MainLayouts>
  );
};

export default DomainBackorder;
